import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const CHECKOUT_URL = 'https://hockeyready.impultienda.ar/checkout';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-125" data-mp="1eiibd833jixo">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-126" data-mp="1j9gwqm2xz77s">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-moss" data-id="element-127" data-mp="1jb1s2dx2yu6p">
          TIJDELIJKE PRIJS
        </p>
        <h2 className="mb-12 text-3xl font-black text-brand-green md:text-4xl" data-id="element-128" data-mp="1s9n5xvrlxl15">
          🏆 Aanbieding voor een Beperkte Tijd
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-orange bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-129" data-mp="1x9rqbwvmyzwn">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-130" data-mp="225qhfs8cmw0r">
            HOCKEY READY
          </div>
          <div className="space-y-4 text-left" data-id="element-131" data-mp="1mh6ld1i2366i">
            <PriceLine label="10 Complete Volumes" price="€87" data-id="element-132" data-mp="1mhzirbv4kjbz" />
            <PriceLine label="5 Exclusieve Bonussen" price="GRATIS" data-id="element-133" data-mp="1howxdr0i4g6v" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-134" data-mp="1cqlmdcygzzn2">
              <span data-id="element-135" data-mp="17sjt5z7byjxv">TOTALE PRIJS:</span>
              <span className="text-brand-goldink line-through" data-id="element-136" data-mp="17tlh349g30x0">€87</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-137" data-mp="25er6bxhp9klu">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-moss" data-id="element-138" data-mp="20hhde7v3qqt9">
              VANDAAG ALLEEN:
            </p>
            <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-green md:text-7xl" data-id="element-139" data-mp="1vfjn4toaavqt">
              €27
            </p>
          </div>
          <CTAButton href={CHECKOUT_URL} className="w-full py-5 text-lg" data-id="element-140" data-mp="k2g18p3i88mp">
            BESTEL HET HOCKEY READY-PAKKET
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-141" data-mp="fzb1uveq0n2a">
            Eenmalige betaling · Direct downloaden · Levenslange toegang
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-142" data-mp="7j29t1efz75b">
      <span className="font-medium" data-id="element-143" data-mp="ch3s3k41n2fq">{label}</span>
      <span className="font-bold text-brand-green" data-id="element-144" data-mp="3uwxxe0f0jm8d">{price}</span>
    </div>;
}